import { useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthContext } from "@/context-state/AuthContext.jsx";
import SignInPage from "@/pages/auth/SignInPage.jsx";
import { MainLoader } from '@/components/loader/MainLoader.jsx'
import AuthLayout from '@/layouts/auth/index.jsx'

export default function AuthGuard({ children }) {

    const { user, isInitialized } = useAuthContext()
    const { pathname } = useLocation()

    const [requestedLocation, setRequestedLocation] = useState(null);

    if (!isInitialized) {
        return <MainLoader className="main-surface bg-cover bg-center bg-no-repeat" />
    }

    if (!user) {
        if (pathname !== requestedLocation) {
            setRequestedLocation(pathname);
        }
        return <AuthLayout><SignInPage /></AuthLayout>
    }

    if (requestedLocation && pathname !== requestedLocation) {
        setRequestedLocation(null)
        return <Navigate to={requestedLocation} />
    }

    return <> {children} </>
}
